import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { Rotor, SelectedPump } from '../models';

@Injectable({
  providedIn: 'root',
})
export class PumpsService {
  constructor(private http: HttpClient) {}

  public getRanges(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.calculationApi}/v1/pump/ranges`);
  }

  public getSizes(range: string): Observable<string[]> {
    return this.http.get<string[]>(`${environment.calculationApi}/v1/pump/ranges/${range}/sizes`);
  }

  public getPressureStages(range: string, size: string): Observable<string[]> {
    return this.http.get<string[]>(
      `${environment.calculationApi}/v1/pump/ranges/${range}/sizes/${size}/pressure-stages`
    );
  }

  public getBaseSizes(range: string, size: string, pressureStage: string): Observable<string[]> {
    return this.http.get<string[]>(
      `${environment.calculationApi}/v1/pump/ranges/${range}/sizes/${size}/pressure-stages/${pressureStage}/base-sizes`
    );
  }

  public getMaxDifferentialPressures(
    size: string,
    pressureStage: string,
    baseSize: string
  ): Observable<number[]> {
    return this.http.get<number[]>(
      `${environment.calculationApi}/v1/pump/sizes/${size}/pressure-stages/${pressureStage}/base-sizes/${baseSize}/max-differential-pressures`
    );
  }

  public getRotors(
    size: string,
    pressureStage: string,
    baseSize: string,
    maxDifferentialPressure: string
  ): Observable<Rotor[]> {
    return this.http.get<Rotor[]>(
      `${environment.calculationApi}/v1/pump/sizes/${size}/pressure-stages/${pressureStage}/base-sizes/${baseSize}/max-differential-pressures/${maxDifferentialPressure}/rotors`
    );
  }

  public getAvailability(selectedPump: SelectedPump): Observable<boolean> {
    const payload = {
      range: selectedPump.range,
      size: selectedPump.size,
      pressureStage: selectedPump.pressureStage,
      baseSize: selectedPump.baseSize,
    };

    return this.http
      .post<{ available: boolean }>(`${environment.calculationApi}/v1/pump/available`, payload)
      .pipe(map((value) => value.available));
  }
}
